<template>
  <div class="employee-page">
    <HeaderBar />

    <main class="content">
      <el-card class="step-card" shadow="hover">
        <div class="copy">
          <p class="step-label">Employee Portal</p>
          <h1>You are not enrolled in the employee portal yet</h1>
          <p class="step-text">
            Would you like to apply as an employee? If you continue, you will start the verification process.
          </p>
        </div>

        <el-alert
          class="status-alert"
          type="info"
          :closable="false"
          title="Applying will open the employee verification flow."
        />

        <div class="actions">
          <el-button
            type="primary"
            size="large"
            :loading="submitting"
            @click="startApplication"
          >
            Yes, apply as an employee
          </el-button>
          <el-button size="large" @click="goBackToPortals">
            Back to portals
          </el-button>
          <el-button size="large" @click="logout">
            Log out
          </el-button>
        </div>
      </el-card>
    </main>
  </div>
</template>

<script>
import HeaderBar from '@/components/HeaderBar.vue'
import { auth, serverTimestamp } from '@/firebase'
import { mergeUserProfile } from '@/services/userProfile'
import { ElMessage } from 'element-plus'
import { signOut } from 'firebase/auth'

export default {
  name: 'EmployeeApplicationPromptView',
  components: { HeaderBar },
  data() {
    return {
      submitting: false,
    }
  },
  methods: {
    async startApplication() {
      if (this.submitting) return

      const user = auth.currentUser
      if (!user) {
        this.$router.push({ name: 'Login' })
        return
      }

      this.submitting = true
      try {
        await mergeUserProfile(user, {
          employeePortal: {
            status: 'verification_required',
            applicationRequestedAt: serverTimestamp(),
          }
        })

        ElMessage({
          type: 'success',
          message: 'Employee application started. Continue with verification.',
          showClose: true,
        })
        this.$router.push({ name: 'EmployeeVerification' })
      } catch (error) {
        ElMessage({
          type: 'error',
          message: error?.message || 'Unable to start the employee application right now.',
          showClose: true,
          duration: 5000,
        })
      } finally {
        this.submitting = false
      }
    },
    goBackToPortals() {
      this.$router.replace({ name: 'CompleteProfile' })
    },
    async logout() {
      try {
        await signOut(auth)
      } catch (e) {}
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
.employee-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f6fbff 0%, #e9f2ff 100%);
  color: #03241f;
}

.content {
  max-width: 780px;
  margin: 36px auto 64px;
  padding: 0 16px;
  box-sizing: border-box;
}

.step-card {
  border-radius: 22px;
  border: 1px solid rgba(3, 36, 31, 0.1);
  box-shadow: 0 20px 48px rgba(3, 36, 31, 0.12);
}

.copy {
  margin-bottom: 22px;
}

.step-label {
  margin: 0 0 8px;
  color: #0b6cff;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.copy h1 {
  margin: 0 0 8px;
  font-size: 2rem;
  font-weight: 800;
}

.step-text {
  margin: 0;
  color: #486a64;
  font-size: 1rem;
}

.status-alert {
  margin-bottom: 24px;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

@media (max-width: 600px) {
  .content {
    margin-top: 28px;
  }

  .copy h1 {
    font-size: 1.7rem;
  }

  .actions {
    flex-direction: column;
  }
}
</style>
